module.exports = __webpack_public_path__ + "img/Group-1923.9a35d4bf.png";